import React from 'react'
import {
  ExecuteOperationOnPipe,
  ForEachModel,
  Model,
  ValueToCollection,
  WhenModelValue
} from '@morningtrain/react-resources'
import { CardGroup, PageHeader, SpaceBetween } from 'ui'
import { TrackButton, TrackCard, TrackCardRow, TrackCardRows, TrackCardTitle, TrackedText } from 'ui/time-tracking'
import AdminPage from 'pages/app/AdminPage'
import { DurationFromSeconds } from 'support/displays'
import {CallbackOnPipe, Pipeline, TriggerPipelineOnClick} from '@morningtrain/react-helpers'
import ToggleTicker from 'pages/app/tablet/ToggleTicker'
import ToggleEmploymentCategoryFilter from 'support/filters/ToggleEmploymentCategoryFilter'
import { Env } from '@morningtrain/helpers'
import { PrimaryHeading } from 'ui/headings'
import TranslatedTitle from 'widgets/TranslatedTitle'
import ToggleBreakOptions from 'pages/app/tablet/ToggleBreakOptions'
import { Translation } from '@morningtrain/react-translations'
import AdministrativeToggleCheckbox from 'pages/app/tablet/AdministrativeToggleCheckbox'
import useDepartmentId from 'support/hooks/use-department-id'
import { SelectedDepartmentFilter } from 'support/filters'

export default function Toggle () {
  const [departmentId] = useDepartmentId()

  return (
    <AdminPage>
      <Model resourceName='toggle.toggle' operationName='index'>
        <SelectedDepartmentFilter />

        <div className='flex items-center justify-between mb-8'>
          <div className='flex items-center space-x-8'>
            <PrimaryHeading>
              <TranslatedTitle name='shifts.tracker.title' />
            </PrimaryHeading>
            <ToggleEmploymentCategoryFilter />
          </div>

          <WhenModelValue name='is_toggle_running' condition>
            <div className='w-96 justify-between flex'>
              <ToggleBreakOptions />
              <AdministrativeToggleCheckbox />
            </div>
          </WhenModelValue>

          <Pipeline>
            <TriggerPipelineOnClick>
              <TrackButton>
                <ToggleTicker />
              </TrackButton>
            </TriggerPipelineOnClick>
            <ExecuteOperationOnPipe
              operationName='start' data={() => {
                return {
                  location: Env.get('toggle.location', null),
                  break: Env.get('toggle.break', 0),
                  department_id: departmentId,
                  administrative: Env.get('toggle.administrative', 0) ? 1 : 0
                }
              }}
            />
            <ExecuteOperationOnPipe operationName='index' />
            <CallbackOnPipe callback={() => Env.set('toggle.break', 0)} />
          </Pipeline>
        </div>

        <div className='mb-8 border-b border-gray-200' />

        <SpaceBetween>
          <TrackedText title='This month' boldTitle>
            <DurationFromSeconds name='duration_this_month' />
          </TrackedText>
          <TrackedText title={<Translation name='toggle.average_duration' />}>
            <DurationFromSeconds name='average_duration' />
          </TrackedText>
        </SpaceBetween>

        <CardGroup className='mt-8'>
          <ValueToCollection name='collection'>
            <ForEachModel>
              <TrackCard>
                <TrackCardTitle />
                <TrackCardRows>
                  <ValueToCollection name='collection'>
                    <ForEachModel>
                      <TrackCardRow />
                    </ForEachModel>
                  </ValueToCollection>
                </TrackCardRows>
              </TrackCard>
            </ForEachModel>
          </ValueToCollection>
        </CardGroup>
      </Model>
    </AdminPage>
  )
}
